import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { LoaderWrapper, ReportHeading, ReportOuterWrapper } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery, useConditionalQuery } from '../../../../hooks'
import CompetitionConsiderationTable from './competitionConsiderationTable'
import { ContentWrap, RootWrap } from './style'
import { exportExcel_addPercentage } from '../../../../util'

const CompetitionConsideration = (props) => {
  const [state, setState] = useState([])
  const [maxValue, setMaxValue] = useState(100)
  const [reportExcelData, setReportExcelData] = useState()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [eventCount, setEventCount] = useState(1)

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: ReportsService.getRelativeBrandsAnalysis,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error } = useConditionalQuery(useReactQueryObject, props)

  const onSuccessFunc = (resp) => {
    const filterItems = resp.filter((item) => !!item?.BrandName)
    const valueArr = filterItems.map((item) => item.BrandPercent)
    setMaxValue(Math.max(...valueArr))
    setState(filterItems)
    updateSubLhsApiLoaded(props)
    setReportExcelData({
      heading: ['Brand Names'],
      values: resp.map((d) => {
        return [{ value: d.BrandName }, exportExcel_addPercentage(d.BrandPercent)]
      }),
    })
    setEventCount((p) => p + 1)
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props.type}
        {...props}
        downloadIdData={reportExcelData}
      />
      <ReportOuterWrapper>
        <RootWrap id={props.type} className={`${(props?.isPPTModalActive || props?.isProgressionActive) ? 'exportToPPT' : ''}`}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            <ContentWrap>
              <CompetitionConsiderationTable maxValue={maxValue} data={state} />
            </ContentWrap>
          </LoaderWrapper>
        </RootWrap>
      </ReportOuterWrapper>
    </>
  )
}

export default CompetitionConsideration
